<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left list-btn" width="5%">
            <router-link
              :to="{ name: 'usersDetail', params: { id: props.item.id }}"
            ><i class="fas fa-search"></i></router-link>
          </td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.name }}</span><pre>{{ props.item.name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.email }}</span><pre>{{ props.item.email }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.device }}</span><pre>{{ props.item.device }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.os }}</span><pre>{{ props.item.os }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.tag }}</span><pre>{{ props.item.tag }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.type }}</span><pre>{{ props.item.type }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</span><pre>{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</pre></v-tooltip></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { usersEventBus } from '@/components/admin/users/usersEventBus';
  import api from '../../../api';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        // NOTE: first init
        isInit: false,
        // NOTE: Table List
        loading: false,
        searchCategory: null,
        search: null,
        pagination: {
          sortBy: null,
          descending: null,
          rowsPerPage: 20,
        },
        totalItems: 0,
        headers: [
          { text: 'View', value: 'id', align: 'left', sortable: false },
          { text: 'Name', value: 'name', align: 'left', sortable: false },
          { text: 'Email', value: 'email', align: 'left', sortable: false },
          { text: 'Device', value: 'device', align: 'left', sortable: false },
          { text: 'Os', value: 'os', align: 'left', sortable: false },
          { text: 'Tag', value: 'tag', align: 'left', sortable: false },
          { text: 'Type', value: 'type', align: 'left', sortable: false },
          { text: 'Updated At', value: 'updated_at', align: 'left' },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['updated_at'],
        // NOTE: Data
        listItems: [],
        filter: [],       // 쿼리문을 담을 배열
      };
    },
    methods: {
      /**
       * @description 필터에 정보가 없을경우 최초 한번만 실행,
       * 필터에 정보가 존재할 경우에는 BookingsFilter에서 eventbus 실행됨
       */
      init() {
        if (_.isEmpty(this.storeFilter)) {
          this.getUserList();
        }
      },
      getUserList() {
        this.loading = true;
        const sortStr = this.pagination.sortBy;
        let orderStr = null;
        if (this.pagination.descending === null) {
          orderStr = null;
        } else if (this.pagination.descending === false) {
          orderStr = 'asc';
        } else if (this.pagination.descending === true) {
          orderStr = 'desc';
        }
        const querystring = {
          sort: sortStr,
          order: orderStr,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage,
          pagination: true,
        };
        for (let index = 0; index < this.filter.length; index += 1) {
          querystring[this.filter[index].searchCategory] = this.filter[index].search;
        }
        api.getUserList(querystring)
        .then((result) => {
          if (result.status === 200) {
            this.totalItems = result.data.total;
            this.listItems = result.data.items;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          this.loading = false;
        });
      },
      /**
       * @description 오름차순/내림차순 정렬
       */
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          this.getUserList();
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    mounted() {
      console.log('bookinglist mount');
      this.init();
      // NOTE: 페이지 로드
      this.$nextTick(() => {
        this.isInit = true;
      });
      this.$nextTick(() => {
        if (!_.isEmpty(this.storePage)) {
          this.pagination = Object.assign({}, this.storePage);
          this.getUserList();
        }
      });
      usersEventBus.$on('initFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.getUserList();
      });
      usersEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        // NOTE: 검색조건이 바뀌므로 첫 페이지로 이동
        this.pagination.page = 1;
        this.getUserList();
      });
      usersEventBus.$on('reloadList', () => this.getUserList());
    },
    updated() {
      storeFilterEventBus.$emit('setPage', this.pagination);
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/users/UsersList.vue